import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import BrokerTransactionTable from '../../AppGrid/BrokerTransactionTable';
import strings from '../../Globalization';

const TransactionList = () => {
	const [activeRecord, setActiveRecord] = useState(null);
	const handleOnOpenForm = ({ record }) => {
		setActiveRecord(record);
	};

	return (
		<Box>
			<BrokerTransactionTable onOpenForm={handleOnOpenForm} />
			<Dialog
				fullWidth
				maxWidth="md"
				open={!!activeRecord}
				sx={{
					zIndex: theme => theme.zIndex.tooltip,
					'& .MuiDialogContentText-root': {
						border: (theme) => `1px solid ${theme.palette.divider}`,
						borderRadius: (theme) => theme.spacing(0.5),
						backgroundColor: 'action.selected',
						padding: (theme) => theme.spacing(2),

					}
				}}
				disableEscapeKeyDown
			>
				<DialogTitle sx={{ display: 'flex', flexDirection: 'row' }}>
					<Typography variant="h5" color="primary" component="div" sx={{ flex: 1 }}>
						{strings.Data}
					</Typography>

					<Button
						onClick={() => setActiveRecord(null)}
						title={strings.Close}
						color="error"
						variant="contained"
						size="small"
						sx={{
							px: 1,
							fontSize: 14,
							textTransform: 'uppercase',
							fontWeight: 'bold',
						}}
					>
						{strings.Close}
					</Button>

				</DialogTitle>
				<Divider />
				<DialogContent>
					{!!activeRecord?.Data && (
						<DialogContentText component="div">
							<pre>{activeRecord?.Data}</pre>
						</DialogContentText>
					)}
				</DialogContent>
			</Dialog>
		</Box>
	);
};

export default TransactionList;
